const TopBarMenuData = [
  {
    isActive: true,
    section: 'Formations',
    elements: [
      {
        isActive: true,
        url: '/apprendre-a-coder-gratuitement/',
        title: 'Préparation HTML/CSS/JS',
        subtitle: [
          {
            item: 'E-learning',
            isBold: true,
          },
          {
            item: ' - Formation gratuite',
          },
        ],
      },
      {
        isActive: true,
        url: '/cours-informatique/formation-developpeur-web-et-web-mobile/',
        title: 'Développeur Web et Web Mobile',
        subtitle: [
          {
            item: 'E-learning + mentoring',
            isBold: true,
          },
          {
            item: ' - 3 à 6 mois',
          },
          {
            item: ' - Bac+2',
          },
        ],
        isNew: false,
        offerType: 'long',
      },
      {
        isActive: true,
        url: '/bootcamp-javascript/concepteur-developpeur-applications-temps-plein/',
        title: `Développeur Web & Mobile + IA`,
        subtitle: [
          {
            item: 'Bootcamp à temps plein',
            isBold: true,
          },
          {
            item: ' - 10 semaines',
          },
          {
            item: ' - Bac+3/4',
          },
        ],
        offerType: 'long',
      },
      {
        isActive: true,
        url: '/formation-alternance/concepteur-developpeur-applications-full-stack-javascript/',
        title: `Développeur Web & Mobile + IA`,
        subtitle: [
          {
            item: 'Formation en alternance',
            isBold: true,
          },
          {
            item: ' - 18 mois',
          },
          {
            item: ' - Bac+3/4',
          },
        ],
        offerType: 'long',
      },
      {
        isActive: false,
        url: '/bootcamp-web3/formation-developpeur-blockchain/',
        title: 'Développeur Blockchain',
        subtitle: [
          {
            item: 'Bootcamp à temps partiel',
            isBold: true,
          },
          {
            item: ' - 9 semaines',
          },
        ],
        isNew: true,
        offerType: 'long',
      },
      /* {
        isActive: false,
        url: '/formation-alternance/developpeur-web-full-stack/',
        title: 'Développeur Full Stack (Bac+2)',
        subtitle: [
          {
            item: 'Alternance',
            isBold: true,
          },
          {
            item: '- 18 mois',
          },
        ],
        isNew: true,
      }, */
    ],
    // width: 370,
  },
  {
    isActive: true,
    section: 'Entreprises',
    link: '/formations-professionnelles/',
    elements: [
      {
        isActive: true,
        url: '/formation/react-redux/',
        title: 'Formation React + Redux',
        subtitle: [
          {
            item: 'Temps plein',
            isBold: true,
          },
          {
            item: ' - 5 jours',
          },
        ],
        offerType: 'short',
      },
      {
        isActive: true,
        url: '/formation/react-native/',
        title: 'Formation React Native',
        subtitle: [
          {
            item: 'Temps plein',
            isBold: true,
          },
          {
            item: ' - 5 jours',
          },
        ],
        offerType: 'short',
      },
      {
        isActive: true,
        url: '/formation/react-avance/',
        title: 'Formation React Avancé',
        subtitle: [
          {
            item: 'Temps plein',
            isBold: true,
          },
          {
            item: ' - 5 jours',
          },
        ],
        isNew: false,
        offerType: 'short',
      },
      {
        isActive: true,
        url: '/formation/typescript/',
        title: 'Formation TypeScript',
        subtitle: [
          {
            item: 'Temps plein',
            isBold: true,
          },
          {
            item: ' - 3 jours',
          },
        ],
        offerType: 'short',
      },
      {
        isActive: true,
        url: '/formation/node-js/',
        title: 'Formation Node.js',
        subtitle: [
          {
            item: 'Temps plein',
            isBold: true,
          },
          {
            item: ' - 3 jours',
          },
        ],
        offerType: 'short',
      },
    ],
  },
  {
    isActive: true,
    section: 'Recruter un alternant',
    link: '/recruter-un-alternant/',
  },
  {
    isActive: true,
    section: 'Réunion d’information',
    link: '/reunion-d-information/',
  },
  {
    isActive: true,
    section: 'Blog',
    link: '/blog/',
  },
];

export { TopBarMenuData };
